import React from 'react';
import { IFormFieldInputBaseProps } from '@components/form-fields';

interface CloseButtonIconProps extends IFormFieldInputBaseProps {
  closeToast?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CloseButtonIcon: React.FC<CloseButtonIconProps> = ({
  closeToast,
  className,
}) => {
  return (
    <button
      type="button"
      aria-label="close"
      className={className}
      onClick={closeToast}
    >
      ✖︎
    </button>
  );
};

export default CloseButtonIcon;
